<template>
    
    <div class="middle-align">
        <TextField
            class="m1"
            :id="'partnerLink'"
            :placeholder="$t('hear_the_music')"
            :value="account.client.settings_HtM_url"
        ></TextField>
    </div>
</template>
<script>
import TextField from '@plugins/text-field/text-field';
import { mapGetters } from 'vuex';
export default {
   data:function()
   {
       return{
           partnerLink:"partnerlink"
       }
   } ,
   computed: {
        ...mapGetters( {
            account: "account"
        })  
    }
}
</script>>
<style scoped>
    .middle-align
    {
        padding: 1em;
    }
</style>>